// Create array of event types
const eventsArray = ['DOMContentLoaded', 'cart:refreshed']

// On each of the event types in eventsArray, run event listener
eventsArray.forEach(event => {
	window.addEventListener(event, () => {
		// Cache all the complementary products elements
		const complementaryProductsSectionEls = document.querySelectorAll('.js-complementary-products')

		// Return early if no section elements found
		if (!complementaryProductsSectionEls) return

		// Loop through each section & load the complementary products
		complementaryProductsSectionEls.forEach(complementaryProductsSectionEl => {
			renderComplementaryProducts(complementaryProductsSectionEl)
		})
	})
})

// Function to load complementary products
async function loadComplementaryProducts(complementaryProductsSectionEl) {
	// Return early if no complementary products section element
	if (!complementaryProductsSectionEl) return

	// Get the cart product ids from the section products dataset
	const productIdsArray = complementaryProductsSectionEl.dataset.products.split(',')

	// Return here if no product IDs found
	if (!productIdsArray) return

	// Get the number of products to show from the complementaryProductsSectionEl productsToShow dataset value
	const productsToShow = complementaryProductsSectionEl.dataset.productsToShow

	// Set the number of products to fetch for each product using productsToShow value divided by the number of products
	const productsToFetchPerProduct = Math.ceil(productsToShow / productIdsArray.length)

	// Query each product for complementary products, returns an array
	const allComplementaryProducts = await Promise.all(productIdsArray.map(productId => {
		return queryComplementaryProductsById({ productId: productId, limit: productsToFetchPerProduct })
	}))

	// Join the returned arrays of complementary products into a single array
	const joinedProductsArray = [].concat(...allComplementaryProducts)

	return joinedProductsArray
}

// Function to query complementary products by product ID
async function queryComplementaryProductsById({ productId, limit }) {
	// Set the url for the product recommendations api endpoint passing product ID as param
	const url = `${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=${limit}&intent=complementary`

	// Fetch the complementary products relating to the product
	const complementaryProducts = await fetch(url)
		.then(response => response.json())
		.then(response => {
			if (!response.products) return

			return response.products
		})
		.catch(error => console.error(error))

	return complementaryProducts
}

// Function to render complementary product cards using template
async function renderComplementaryProducts(complementaryProductsSectionEl) {
	// Load the complementary products
	const complementaryProducts = await loadComplementaryProducts(complementaryProductsSectionEl)

	// Clear the existing products list to prevent duplications / unintended renders
	clearComplementaryProductsList(complementaryProductsSectionEl)

	// Render the product cards
	complementaryProducts.map((complementaryProduct, index) => {
		// Get the complementary products list element
		const complementaryProductsListEl = complementaryProductsSectionEl.querySelector('.js-complementary-products-list')

		// Get the complementary product card element in the list if it exists
		const complementaryProductCardEl = complementaryProductsSectionEl.querySelector(`[data-product-card="${complementaryProduct.variants[0].id}"]`)

		// Return early if no complementary products section element or if the card already exists
		if (!complementaryProductsListEl || complementaryProductCardEl) return

		// Get the colour theme from the section element theme dataset attr
		const theme = complementaryProductsSectionEl.dataset.theme

		// Generate the HTML cart upsell card template
		const template = document.createElement('li')
		template.classList.add('complementary-products__list-item')
		template.classList.add('js-cart-upsell-card')
		template.setAttribute('data-product-card', complementaryProduct.variants[0].id)
		template.innerHTML = `
			<div class="cart-upsell-card">
				<div class="cart-upsell-card__upper">
					<div class="cart-upsell-card__media">
						<img
							width="238"
							height="178"
							loading="lazy"
							class="cart-upsell-card__image"
							src="${complementaryProduct.images}"
							alt="${complementaryProduct.title}"
						>
					</div>
				</div>

				<div class="cart-upsell-card__lower">
					<div class="cart-upsell-card__title CartItem__Title Heading">
						<a href="${complementaryProduct.url}">
							<span>
								${complementaryProduct.title}
							</span>
						</a>
					</div>

					<div class="cart-upsell-card__actions">
						<form
							class="js-add-to-cart-form"
							action="/cart/add"
							method="post"
							enctype="multipart/form-data"
							data-product-id="${complementaryProduct.variants[0].id}"
						>
							<input
								class="js-add-to-cart-quantity"
								type="hidden"
								name="quantity"
								value="1"
							>

							<div class="cart-upsell-card__variants">
								<select class="CartItem__Title cart-upsell-card__variant-select js-cart-upsell-card-variant-select ${complementaryProduct.variants.length <= 1 ? 'hidden' : ''}">
									${complementaryProduct.variants.map(variant => `
										<option value="${variant.id}">${variant.title}</option>
									`)}
								</select>
							</div>

							<button
								type="button"
								class="Button ${theme === 'light' ? 'Button--secondary' : 'Button--primary'} Button--small js-cart-upsell-card-button js-add-to-cart"
								data-cart-upsell-card-button
							>
								Add
							</button>
						</form>
					</div>
				</div>
			</div>
		`

		// Render the product cards at the complementary products list element
		complementaryProductsListEl.appendChild(template)

		// Set the section loading state to false
		complementaryProductsSectionEl.dataset.loading = false
	})
}

// Function to remove all product list nodes from a complementary product section
function clearComplementaryProductsList(complementaryProductsSectionEl) {
	// Get the complementary products list element
	const complementaryProductsListEl = complementaryProductsSectionEl.querySelector('.js-complementary-products-list')

	// Clear the existing contents of the list product list element
	complementaryProductsListEl.innerHTML = ''
}
